import React, { FC } from "react";
import { styled } from "@mui/system";
import { SPACINGS } from "../../common/consts";
import { useRecoilValue } from "recoil";
import { extensibilitySdkInitializedAtom, signedInUserAtom } from "../../state/atoms";
import { useCrm } from "../CrmUi/useCrm";
import HubSpotTopBar from "./HubSpotTopBar";

const StyledContainer = styled("div")<{ paddingY: string; flush?: boolean }>`
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  padding-top: ${({ flush, paddingY }) => (flush ? "0" : paddingY)};
  padding-right: ${({ flush }) => (flush ? "0" : SPACINGS.xl)};
  padding-bottom: ${({ flush, paddingY }) => (flush ? "0" : paddingY)};
  padding-left: 0;
  background-color: ${({ flush }) => (flush ? "#F4F5F7" : "transparent")};
  transition: background-color 0.3s ease;
`;

/* HubSpot orgs: the navy top bar runs edge to edge, and the page keeps the
   usual padding underneath it. */
const HubSpotShell = styled("div")`
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

const HubSpotPage = styled("div")<{ paddingY: string }>`
  flex: 1 1 auto;
  min-height: 0;
  padding: ${({ paddingY }) => paddingY} ${SPACINGS.xl};

  /* The dashboard brings HubSpot's own app layout, edge to edge (it sits a
     few wrappers down, so not only as a direct child). */
  &:has(.hs-app) {
    padding: 0;
  }
`;

interface Props {
  children?: React.ReactNode;
  /** Outreach extension frames already sit in their well — no dashboard chrome. */
  flush?: boolean;
}

const AppContainer: FC<Props> = ({ children, flush }) => {
  const isExtensibilitySdkInitialized = useRecoilValue(
    extensibilitySdkInitializedAtom
  );
  const signedInUser = useRecoilValue(signedInUserAtom);
  const crm = useCrm();
  const paddingY = isExtensibilitySdkInitialized ? SPACINGS.none : SPACINGS.xl;

  if (crm === "hubspot" && !flush && signedInUser) {
    return (
      <HubSpotShell>
        <HubSpotTopBar />
        <HubSpotPage paddingY={paddingY}>{children}</HubSpotPage>
      </HubSpotShell>
    );
  }

  return (
    <StyledContainer
      flush={flush}
      paddingY={paddingY}
    >
      {children}
    </StyledContainer>
  );
};

export default AppContainer;
